// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"castle-6"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M16 9H21V21H3V9H8V3H16V9Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M18 13C19.6569 13 21 14.3431 21 16V21H3V16C3 14.3431 4.34315 13 6 13C7.65685 13 9 14.3431 9 16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16C15 14.3431 16.3431 13 18 13Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12 7V9M9 21V16M9 21H3V16C3 14.3431 4.34315 13 6 13C7.65685 13 9 14.3431 9 16M9 21H15M9 16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16M15 21V16M15 21H21V16C21 14.3431 19.6569 13 18 13C16.3431 13 15 14.3431 15 16","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M7 3H17M8 9V3H16V9H8ZM3 9H21V21H3V9Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-castle-6')
export default class Castle6Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'castle-6',
    }
  }
}
